import type { JSX } from 'react';
import { useState } from 'react';
import { Button } from '@/components/ui/button.js';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog.js';
import { Field } from '@/components/ui/field.js';
import { Textarea } from '@/components/ui/input.js';

export interface IgnoreReasonDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  isSubmitting?: boolean;
  onConfirm: (reason: string) => void;
}

/** Dialogue « Ignorer » avec motif obligatoire — lignes de fulfillment et factures Pennylane (`02` §6, §7). */
export function IgnoreReasonDialog({
  open,
  onOpenChange,
  title,
  description,
  isSubmitting = false,
  onConfirm,
}: IgnoreReasonDialogProps): JSX.Element {
  const [reason, setReason] = useState('');

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) {
          setReason('');
        }
        onOpenChange(next);
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <Field label="Motif" htmlFor="ignore-reason">
          <Textarea
            id="ignore-reason"
            value={reason}
            onChange={(event) => {
              setReason(event.target.value);
            }}
          />
        </Field>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => {
              onOpenChange(false);
            }}
          >
            Annuler
          </Button>
          <Button
            variant="destructive"
            disabled={reason.trim().length === 0}
            isLoading={isSubmitting}
            onClick={() => {
              onConfirm(reason.trim());
            }}
          >
            Ignorer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
